import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountService, GenerateOTPResponse } from '../../../../../../services/account/account.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../utils';


@Component({
  selector: 'app-set-up-two-factor-authentication-modal',
  templateUrl: './set-up-two-factor-authentication-modal.component.html',
  styleUrls: ['./set-up-two-factor-authentication-modal.component.css']
})
export class SetUpTwoFactorAuthenticationModalComponent implements OnInit {

  @Input() savedCallback: (result: CallbackResult) => undefined;

  public generateOTPResponse: GenerateOTPResponse = null;

  // Whether the user has confirmed their authenticator app set up. Once this
  // is true, they will be prompted to enter an OTP token for verification.
  public setUpConfirmed = false;
  public verifyToken = '';

  public errorMessage = '';
  public serverError: number = null;

  public loadingGenerateOTP = true;
  public loadingVerifyOTP = false;

  constructor(
    public activeModal: NgbActiveModal,
    private accountService: AccountService,
  ) {}

  ngOnInit() {
    this.generateOTP();
  }

  public verifyOTP() {
    this.loadingVerifyOTP = true;
    this.errorMessage = '';

    this.accountService
      .verifyOTP(this.verifyToken)
      .then(() => {
        this.savedCallback({
          text: 'Two-factor authentication has been set up successfully. A code from your authenticator app will be required when logging into the Staff Site in the future.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
          this.verifyToken = '';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingVerifyOTP = false; });
  }

  public getManualCodeFormatted() {
    if (this.generateOTPResponse === null) { return ''; }

    return this.generateOTPResponse.otp_secret_key
      .replace(/(.{4})/g, '$1 ')
      .trim();
  }

  private generateOTP() {
    this.loadingGenerateOTP = true;

    this.accountService
      .generateOTP()
      .then(result => {
        this.generateOTPResponse = result;
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.savedCallback({
            text: reason.error,
            status: CallbackResultStatus.error
          });
          this.activeModal.close();
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingGenerateOTP = false; });
  }
}
